import React from "react";
import cn from 'classnames';
import {withModels} from "game_play/utils/store";
import Sector from "game_play/component/Sector";

import {Number} from '../utils'
import dartsIcon from '../../static/game/image/darts.svg';

class ScoreView extends React.Component {
  renderSector(sector, p) {
    const {Game} = this.props;
    const leg = Game.data
    const sectors = Game.getSectorsBySector(leg, sector, p)
    return <Sector sectors={sectors} target={sector}/>
  }

  render() {
    const {Game} = this.props
    const {winner_number, start_time, end_time, score_1, score_2} = Game.get('game')
    const first = Game.first
    const leg = Game.data
    const is_gaming = start_time && !end_time
    const [darts_1, darts_2] = Game.getDarts(leg)
    const [, p] = Game.getSelected()
    const [score_leg_1, score_leg_2] = Game.calculateScore(leg)

    return (
      <div className="info-score score-cricket">
        <div className="info-score__line">
          <div className="info-score__title">Legs</div>
          <div className="info-score__score">
            <span className={cn('info-score__legs-first', {
              'hidden': first !== 0 || !is_gaming
            })}></span>
            <Number value={score_1} className={cn({
              'info-score__winner': winner_number === 1
            })}/>
            <span style={{padding: '0 5px'}}>-</span>
            <Number value={score_2} className={cn({
              'info-score__winner': winner_number === 2
            })}/>
            <span className={cn('info-score__legs-first', {
              'hidden': first !== 1 || !is_gaming
            })}></span>
          </div>
        </div>
        <div className="info-score__line ">
          {Game.WITH_SCORE ? (
            <>
              <div className="info-score__title">Score</div>
              <div className="info-score__score -big">
                <Number value={score_leg_1} className={cn({
                  'info-score__score_play': is_gaming && p === 0,
                })}/>
                <span style={{padding: '0 5px'}}>-</span>
                <Number value={score_leg_2} className={cn({
                  'info-score__score_play': is_gaming && p === 1,
                })}/>
              </div>
            </>
          ) : (
            <div className="info-score__darts">
              <Number value={darts_1} className={cn({
                'info-score__score_play': is_gaming && p === 0,
              })}/>
              <img src={dartsIcon} alt='darts' style={{padding: '0 5px'}}/>
              <Number value={darts_2} className={cn({
                'info-score__score_play': is_gaming && p === 1,
              })}/>
            </div>
          )}
        </div>
        <div className='info-score__table score-cricket__table'>
          {Game.sectors.map((sector, i) => {
            return (
              <React.Fragment key={i}>
                <div className="info-score__td">
                  {this.renderSector(sector, 0)}
                </div>
                <div className="info-score__td" style={{padding: 0}}>{sector === 25 ? 'Bull' : sector}</div>
                <div className="info-score__td">
                  {this.renderSector(sector, 1)}
                </div>
              </React.Fragment>
            )
          })}
        </div>
      </div>
    );
  }
}

export default withModels(ScoreView)